<template>
  <div class="moduleCard">
    <div class="row mt-4">
      <div class="col-7">
        <div class="row mt-2">
          <div class="col-6">
            <h3 id="available_products">Available Products</h3>
          </div>
          <div class="col-6 text-right">
            <button class="btn-std" @click="doLeftSelectAll" name="select_all">Select All</button>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-12">
            <span name="search">Search</span>: <input type="text" class="fullWidth" v-model="leftSearch" @keyup="doLeftSearch" />
          </div>
        </div>

        <div class="mt-2 scroll">
          <select multiple="true" id="selectFrom" class="mSelect">
            <option v-for="i of showItems" v-bind:value="i.LicensePoolProductID" @dblclick="doItemSelect">
              {{i.ConsolidatedName}}
            </option>
          </select>
        </div>
      </div>
      <div class="col-1 midcolumn text-center">
        <div>
          <button class="btn-transparent" @click="doItemSelect">
            <img src="@/assets/images/scriptingScrollRight.png" alt="Select" />
          </button>
        </div>
        <div class="mt-5">
          <button class="btn-transparent" @click="doItemDeselect">
            <img src="@/assets/images/scriptingScrollLeft.png" alt="Deselect" />
          </button>
        </div>
      </div>
      <div class="col-4">
        <div class="row mt-2">
          <div class="col-6">
            <h3 id="selected_products">Selected Products</h3>
          </div>
          <div class="col-6 text-right">
            <button class="btn-std" @click="doRightSelectAll" name="select_all">Select All</button>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12">
            <span name="search">Search</span>: <input type="text" class="fullWidth" v-model="rightSearch" @keyup="doRightSearch" />
          </div>

        </div>
        <div class="mt-2 scroll">
          <select multiple="true" id="selectTo" class="mSelect">
            <option v-for="i of showSelectedItems" v-bind:value="i.LicensePoolProductID">
              {{i.ProductName}}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-12 text-right">
        <button class="btn btn-primary btn-short" @click="doSelect" id="select">Select</button>
      </div>
    </div>
  </div>

</template>


<script>
  export default {
    name: "SelectProducts",
    props:["consolidateLicenses","showZeroItems"],
    data() {
      return {
        leftSearch:"",
        rightSearch:"",
        itemPool:[],
        selectedItems:[],
        showItems:[],
        showSelectedItems:[],
      }
    },
    methods: {
      doItemDeselect() {
        var sOptions = Array.prototype.slice.call(document.querySelectorAll('#selectTo option:checked'),0).map(function(v,i,a) { 
          return v; 
        });
        for(var q=0; q<sOptions.length; q++) {
          var i = sOptions[q];
          var rid=-1;
          for (var x=0; x<this.selectedItems.length; x++) {
            if (this.selectedItems[x].LicensePoolProductID===i.value) {
              rid=x;
            }
          }
          if (rid>-1) {
            this.selectedItems.splice(rid,1);
          }
        }
        this.rightSearch="";
        this.showSelectedItems=this.selectedItems;
        this.$forceUpdate();
      },
      doItemSelect() {
        var sOptions = Array.prototype.slice.call(document.querySelectorAll('#selectFrom option:checked'),0).map(function(v,i,a) { 
          return v; 
        });
        for(var x=0; x<sOptions.length; x++) {
          var i = sOptions[x];
          if (this.selectedItems.filter(p=>p.LicensePoolProductID===i.value).length===0) {
            var ipi = this.itemPool.filter(p=>p.LicensePoolProductID===i.value);
            if (ipi.length>0) {
              this.selectedItems.push(ipi[0]);
            }
          }
        }
        this.rightSearch="";
        this.showSelectedItems=this.selectedItems;
        this.$forceUpdate();
      },
      doLeftSearch() {
        if (this.leftSearch.length>0) {
          this.showItems=[];
          for(var u of this.itemPool) {
            if (u.ProductName.toLowerCase().indexOf(this.leftSearch.toLowerCase())>-1) {
              this.showItems.push(u);
            }
          }
        }
        else {
          this.showItems=this.itemPool;
        }
        this.$forceUpdate();
      },
      doRightSearch() {
        if (this.rightSearch.length>0) {
          this.showSelectedItems=[];
          for(var u of this.selectedItems) {
            if (u.ProductName.toLowerCase().indexOf(this.rightSearch.toLowerCase())>-1) {
              this.showSelectedItems.push(u);
            }
          }
        }
        else {
          this.showSelectedItems=this.selectedItems;
        }
        this.$forceUpdate();
      },
      doLeftSelectAll() {
        for (var i = 0; i < document.getElementById("selectFrom").options.length; i++) {
          document.getElementById("selectFrom").options[i].selected = true;
        }
      },
      doRightSelectAll() {
        for (var i = 0; i < document.getElementById("selectTo").options.length; i++) {
          document.getElementById("selectTo").options[i].selected = true;
        }
      },
      doSelect() {
        this.$parent.doneSelection(this.selectedItems);
      },
      setData(ip) {
        this.itemPool=[];
        for(var x=0; x<ip.length; x++) {
          try {
            var i=ip[x];
            if (i.LicensesNumber>0 || this.showZeroItems) {

              if (this.consolidateLicenses) {
                if (this.itemPool.filter(p=>p.ProductName===i.ProductName).length===0) {
                  i.ConsolidatedName=i.ProductName;
                  this.itemPool.push(i);
                }
              }
              else {
                switch(i.LicenseType) {
                  case 0: i.MLicenseType="Single-User"; break;
                  case 1: i.MLicenseType="Hourly ("+i.LicenseMinutes+" Minutes)"; break;
                  case 2: i.MLicenseType="Collaborator"; break;
                  case 3: i.MLicenseType="Free with Expiration (Term: "+i.LicenseTerm+" Days)"; break;
                  case 4: i.MLicenseType="Recurring (Expires: "+this.buildDateTime(i.LicenseExpirationDate, false)+")"; break;
                }

                if (i.LicenseType===4 && new Date(i.LicenseExpirationDate).getTime()<new Date().getTime()) {
                  continue;
                }

                i.ConsolidatedName=i.ProductName+" ["+i.MLicenseType+", "+i.LicensesNumber+" Available]"

                this.itemPool.push(i);
              }            
              
             }
        
           }
           catch(e) {
             console.log(e);
           }
        
         }

         this.showItems=this.itemPool;
      }


    }
  }
</script>
